import { ADD_LANGUAGE, DELETE_LANGUAGE } from '../types';
import { createAxiosAction } from '../utils';

export default {
  addLanguage: (projectId, code, description) => {
    return createAxiosAction({
      url: `/api/v1/languages`,
      body: {
        projectId,
        code,
        description,
      },
      method: 'POST',
      startAction: ADD_LANGUAGE,
    });
  },
  deleteLanguage: languageId => {
    return createAxiosAction({
      url: `/api/v1/languages/${languageId}`,
      method: 'DELETE',
      startAction: DELETE_LANGUAGE,
    });
  },
};
